// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/app.scss
// module id = 238
// module chunks = 1